const isLoggedIn = () => localStorage.getItem('access');

const logOut = () => {
  localStorage.removeItem('access');
  localStorage.removeItem('refresh');
  window.location.reload();
};

const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return {};
  }
};

const getTokenData = () => parseJwt(isLoggedIn());

const downloadFile = (fileInfo) => {
  let files;
  if (!Array.isArray(fileInfo)) files = [fileInfo];
  else files = [...fileInfo];

  const temporaryDownloadLink = document.createElement('a');
  temporaryDownloadLink.style.display = 'none';
  document.body.appendChild(temporaryDownloadLink);
  files.forEach(async (file) => {
    if (file.url) {
      const imgUrl = await fetch(file.url);
      const imgBlog = await imgUrl.blob();
      const imageURL = URL.createObjectURL(imgBlog);
      temporaryDownloadLink.setAttribute('href', imageURL);
      temporaryDownloadLink.setAttribute('download', file.name);
      temporaryDownloadLink.click();
    }
  });
  document.body.removeChild(temporaryDownloadLink);
};

const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export {
  isLoggedIn, logOut, parseJwt, getTokenData, debounce, downloadFile,
};
